export function createFinancialDataRow(financialData) {
  const lengthPerLine = 30 // Update this to control max length per line

  const breakIntoLines = (str, lines = [], remainingStr = str) => {
    if (!str) return ['']

    if (remainingStr.length <= lengthPerLine) {
      return lines.length === 0 ? [remainingStr] : [...lines, remainingStr]
    }

    const pos = remainingStr.substring(0, lengthPerLine).lastIndexOf(' ')
    const actualPos = pos <= 0 ? lengthPerLine : pos
    const newLine = remainingStr.substring(0, actualPos)

    if (lines.length === 1) {
      return [...lines, newLine + '...']
    }

    const i = remainingStr.indexOf(' ', actualPos) + 1
    const nextIndex =
      i < actualPos || i > actualPos + lengthPerLine ? actualPos : i
    const newRemainingStr = remainingStr.substring(nextIndex)

    return breakIntoLines(str, [...lines, newLine], newRemainingStr)
  }

  const convertCentsToAmount = (field) => {
    return financialData.map((item) =>
      item && item[field] ? Math.round(item[field] / 100) : 0
    )
  }
  // Sort financialData array by budget in descending order
  financialData.sort((a, b) => b.totalAmountCents - a.totalAmountCents)

  const budget = convertCentsToAmount('totalAmountCents')
  const realized = convertCentsToAmount('totalAmountRealizedCents')
  const lastYearRealized = convertCentsToAmount('lastYearAmountRealizedCents')

  return {
    name: financialData.map((item) => breakIntoLines(item?.name)),
    fullName: financialData.map((item) => item?.name || ''),
    budget: budget,
    realized: realized,
    lastYearRealized: lastYearRealized,
  }
}

export function compareArrayForOptions(
  context,
  compareArray,
  firstOption,
  secondOption
) {
  const index = context.dataIndex
  const dataValue = context.dataset.data[index]
  return dataValue > compareArray[index] ? firstOption : secondOption
}
